import * as React from 'react';
import { Layout, Sidebar, AppBar, LocalesMenuButton } from 'react-admin';
import { UserMenu } from './../components/userMenu/userMenu.component';
import Menu from './../components/menu/menu.component';
import { languages } from '../i18n/languges';

const CustomSidebar = (props: any) => <Sidebar {...props} size={200} />;
const CustomAppBar = (props: any) => <AppBar {...props} userMenu={<UserMenu />} toolbar={<LocalesMenuButton languages={languages} />} />

export const CustomLayout = (props: any) => (
    <Layout
        {...props}
        appBar={CustomAppBar}
        sidebar={CustomSidebar}
        menu={Menu}
    />
);

export default CustomLayout;